import React from 'react'
import { lazyWithSuspense } from '../utils/lazy-with-suspense'
import { ROUTER_PATH } from './constants'
import { RouteConfig } from '../types'

export const PublicRoutes: RouteConfig[] = [
  {
    path: ROUTER_PATH.authBridge,
    component: lazyWithSuspense(() => import('@pages/authBridge/page')),
  },
  {
    path: ROUTER_PATH.help,
    component: lazyWithSuspense(() => import('@components/HelpPage/HelpPage')),
  },
  {
    path: ROUTER_PATH.noAccount,
    component: lazyWithSuspense(() => import('@pages/login/noAccount/page')),
  },
  {
    path: ROUTER_PATH.oauth.callback,
    component: lazyWithSuspense(() => import('@/pages/oauth/callback/page')),
  },
]

export const MainRouters: RouteConfig[] = [
  {
    path: ROUTER_PATH.dashboard,
    component: lazyWithSuspense(() => import('@pages/dashboard/page')),
  },
  {
    path: ROUTER_PATH.timeEntries,
    component: lazyWithSuspense(() => import('@pages/grid/page')),
  },
  {
    path: ROUTER_PATH.settings,
    component: lazyWithSuspense(() => import('@pages/settings/page')),
  },
]
